import service from '@/utils/server';

const modName = '/tms/sch/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'searchSchOrderList',
    method: 'post',
    data
  });
};

//导入
export const importTransportPlan = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    },
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'importTransportPlan',
    method: 'post',
    data
  });
};

//导出
export const exportSchOrderForPlanImport = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'exportSchOrderForPlanImport',
    method: 'post',
    data
  });
};

/**
 * 指派承运商提交
 * @param data
 * @returns {*}
 */
export const assignCarrier = data => {
  return service({
    url: modName + 'assignCarrier',
    method: 'post',
    data
  });
};

/**
 * 新增前置校验
 * @param data
 * @returns {*}
 */
export const  createScheduValidateParam = data => {
  return service({
    url: modName + 'createScheduValidateParam',
    method: 'post',
    data
  });
};

/**
 * 保存提交
 * @param data
 * @returns {*}
 */
export const createScheduInfo = data => {
  return service({
    url: modName + 'createScheduInfo',
    method: 'post',
    data
  });
};



/**
 * 上传附件
 * @param data
 * @returns {*}
 */
export const uploadFile = data => {
  let config={
    headers: {
      "Accept": '*/*',
      'Content-Type': 'multipart/form-data'
    }
  }
  return service({
    ...config,
    url: modName + 'uplodFile',
    method: 'post',
    data
  });
};

/**
 * 分段初始化前置校验
 * @param data
 * @returns {*}
 */
export const initSegmentation = data => {
  return service({
    url: modName + 'scheduSplitParagraphsValidateParam',
    method: 'post',
    data
  });
};

/**
 * 分段提交
 * @param data
 * @returns {*}
 */
export const scheduSplitParagraphs = data => {
  return service({
    url: modName + 'scheduSplitParagraphs',
    method: 'post',
    data
  });
};
/**
 * 运输信息->点击发货方-打开预约量弹出框查询详情,这里只针对亿滋
 * @param data
 * @returns {*}
 */
export const getCallSctRdc = data => {
  return service({
    url: modName + 'callSctRdc',
    method: 'post',
    data
  });
};

/**
 * 分量
 * @param data
 * @returns {*}
 */
export const scheduSplitQuantityValidateParam = data => {
  return service({
    url: modName + 'scheduSplitQuantityValidateParam',
    method: 'post',
    data
  });
};

/**
 * 分量提交
 * @param data
 * @returns {*}
 */
export const scheduSplitQty = data => {
  return service({
    url: modName + 'scheduSplitQty',
    method: 'post',
    data
  });
};

/**
 * 撤销分量
 * @param data
 * @returns {*}
 */
export const returnScheduSplitQty = data => {
  return service({
    url: modName + 'returnScheduSplitQty/'+ data.schOrderNo,
    method: 'post'
  });
};

/**
 * 撤销分段
 * @param data
 * @returns {*}
 */
export const returnschedusplitParagraphs = data => {
  return service({
    url: modName + 'returnScheduSplitParagraphs/'+ data.schOrderNo,
    method: 'post'
  });
};

//订单查询
export const schedulingJobBillList = data => {
  return service({
    url: modName + 'schedulingJobBillList',
    method: 'post',
    data
  });
};

/**
 * 增加订单校验
 * @param data
 * @returns {*}
 */
export const schedulingCreateValidateParam = data => {
  return service({
    url: modName + 'schedulingCreateValidateParam',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/transport/reservation/api/index.js